(function () {
    'use strict';

    angular
        .module('portalApp')
        .controller('PublicCurvesController', PublicCurvesController);

    PublicCurvesController.$inject = ['DateUtils', 'publicCurves'];

    function PublicCurvesController(DateUtils, publicCurves) {
        var vm = this;

        vm.curves = publicCurves;
        // the date comes from the server (Prague); today's local date only if the curves could not be loaded
        vm.date = (publicCurves && publicCurves.date) ? DateUtils.convertLocalDateFromServer(publicCurves.date) : new Date();
        vm.conventionsUrl = 'content/pdf/EBRD curves conventions.pdf';
    }
})();
